<div class="appeal-document">
	<a
		class="appeal-document__link"
		(click)="open($event)"
		[href]="document.file"
	>
		{{ document.fileName }}
	</a>
</div>
